import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import { baseUrl, userName, ipAddress } from './Univ.js';

function AddBoothReport() {

  const [booths, setBooths] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

const [reportData, setReportData] = useState({
  booth: '',
  issue: '',
  mood: 3,
  notes: '',
  reporter: userName
});


  /* ---------------- HANDLE CHANGE ---------------- */
const handleChange = (event) => {
  const { name, value } = event.target;

  setReportData({
    ...reportData,
    [name]: name === 'booth' || name === 'mood'
      ? Number(value)
      : value
  });
};
const formSubmit = () => {

  if (!reportData.booth || !reportData.issue) {
    Swal.fire('Error', 'Please select Booth and Issue', 'error');
    return;
  }

  const _formData = new FormData();

  _formData.append('booth', reportData.booth);   // FK id ✅
  _formData.append('issue', reportData.issue);   // string ✅
  _formData.append('mood', reportData.mood);     // number ✅
  _formData.append('notes', reportData.notes);   // text ✅
  _formData.append('reporter', userName); // text ✅


  for (let pair of _formData.entries()) {
    console.log(pair[0], pair[1]);
  }

  axios.post(baseUrl + 'boothreports/', _formData)
    .then(response => {
      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          title: 'Report added',
          icon: 'success',
          timer: 3000,
          showConfirmButton: false
        });
        setTimeout(() => window.location.reload(), 1000);
      }
    })
    .catch(error => {
      console.error(error.response?.data || error);
      Swal.fire('Error', 'Failed to add report', 'error');
    });
};

  /* ---------------- FETCH REPORTS ---------------- */
  const fetchReports = () => {
    setIsLoading(true);
    axios.get(baseUrl + 'boothreports/')
      .then(response => {
        setRows(response.data);
        setIsLoading(false);
      })
      .catch(error => setIsLoading(false));
  };

  /* ---------------- FETCH BOOTHS ---------------- */
  const fetchBooths = () => {
    axios.get(baseUrl + 'booths/')
      .then(response => setBooths(response.data))
      .catch(error => console.log(error));
  };

  useEffect(() => {
    fetchBooths();
    fetchReports();
  }, []);

  /* ---------------- DELETE ---------------- */
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Confirm',
      text: 'Are you sure you want to delete this report?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete'
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + 'delete-booth-report/' + id + '/')
          .then(() => {
            Swal.fire('Deleted', 'Report deleted', 'success');
            setTimeout(() => window.location.reload(), 1000);
          });
      }
    });
  };

  /* ---------------- DATAGRID COLUMNS ---------------- */
  const columns = [
    { field: 'id', headerName: 'ID', width: 80 },
   {
      field: 'consituency',
      headerName: 'Consituency',
      width: 200,
      renderCell: (params) => {
        if (params && params.row && params.row.booth.constituency) {
          if (params.row.booth.constituency !== null && params.row.booth.constituency !== 0) {
            return params.row.booth.constituency.name;
          }
        }
        return 'Unknown';
      },
    },
    {
      field: 'booth',
      headerName: 'Booth Number',
      width: 200,
      renderCell: (params) => {
        if (params && params.row && params.row.booth) {
          if (params.row.booth !== null && params.row.booth !== 0) {
            return params.row.booth.booth_number;
          }
        }
        return 'Unknown';
      },
    },
    { field: 'issue', headerName: 'Issue', width: 120 },
  {
  field: 'mood',
  headerName: 'Mood',
  width: 120,
  renderCell: (params) => {
    if (!params?.row) return 'N/A'; // <-- safe check
    switch(params.row.mood) {
      case 1: return 'Very Bad';
      case 2: return 'Bad';
      case 3: return 'Neutral';
      case 4: return 'Good';
      case 5: return 'Very Good';
      default: return 'N/A';
    }
  }
},
    { field: 'notes', headerName: 'Notes', width: 200 },
    {
  field: 'reporter',
  headerName: 'Reported By',
  width: 150,
  renderCell: (params) => {
    return params?.row?.reporter || 'N/A';
  },
},
    { field: 'created_at', headerName: 'Created At', width: 180 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(params.row.id)}>Delete</button>
      )
    }
  ];

  return (
    <section className="container mt-4">
      <div className="card">
        <h4 className="card-header">Add Booth Report</h4>
        <div className="card-body">
          <form>
            <div className="mb-3">
              <label className="form-label">Booth</label>
              <select className="form-control" name="booth" value={reportData.booth} onChange={handleChange}>
                <option value="">-- Select Booth --</option>
                {booths.map(b => (
                  <option key={b.id} value={b.id}>{b.booth_number}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Issue</label>
              <select className="form-control" name="issue" value={reportData.issue} onChange={handleChange}>

  <option value="">-- Select Issue --</option>
  <option value="light_post">💡 Light Post</option>
  <option value="water_pipe">💧 Water Pipe</option>
  <option value="road">🛣 Road</option>
  <option value="sewage">🚰 Sewage</option>
  <option value="eb_line">⚡ EB Line</option>
  <option value="encroachment">🚫 Encroachment</option>
  <option value="waste_mgmt">🗑 Waste Management</option>
  <option value="public_safety">🛡 Public Safety</option>
  <option value="others">⋯ Others</option>
</select>

            </div>
            <div className="mb-3">
              <label className="form-label">Mood</label>
              <select
                name="mood"
                value={reportData.mood}
                onChange={handleChange}
                className="form-control"
              >
              <option value="">-- Select Mood --</option>
              <option value="1">Very Bad</option>
              <option value="2">Bad</option>
              <option value="3">Neutral</option>
              <option value="4">Good</option>
              <option value="5">Very Good</option>
            </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Notes</label>
              <textarea
                name="notes"
                value={reportData.notes}
                onChange={handleChange}
                className="form-control"
                rows={3}
                placeholder="Add additional notes here..."
              />
            </div>


            <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
          </form>
        </div>
      </div>

      <div style={{ width: '100%' }} className="mt-4">
           <DataGrid
          className="mt-4"
          rows={rows}
          columns={columns}
          loading={isLoading}
          pageSize={25}
          rowsPerPageOptions={[25, 50, 100]}
          components={{ Toolbar: GridToolbar }}
          autoHeight
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main'
            }
          }}
        />
      </div>
    </section>
  );
}

export default AddBoothReport;
